import PropTypes from "prop-types";
import React from "react";
import { Carousel } from "../common/components/Carousel";

export function Upgrades({ packageName, modules, children }) {
	const upgrades = modules.map((item, index) => (
		<div key={index} className="card">
			<p className="title">{item.title}</p>
			<p className="content">{item.content}</p>
			<a href={item.url} className="link">
				Explore
			</a>
		</div>
	));
	const multipleRows = modules.length > 2;

	return (
		<section className="section--upgrades section--dark">
			<div className="container">
				<h2 className="section-title">
					More ways to enhance your data
				</h2>
				<p className="section-description">
					You can upgrade your {packageName} with the following data:
				</p>

				<Carousel
					options={{
						className: multipleRows ? "multiple-rows" : "",
						dots: false,
						rows: multipleRows ? 2 : 1,
						slidesToShow: 1,
						slidesPerRow: 2,
						responsive: [
							{
								breakpoint: 768,
								settings: {
									className: "",
									rows: 1,
									slidesPerRow: 1,
									slidesToScroll: 2,
									slidesToShow: 2,
								},
							},
							{
								breakpoint: 576,
								settings: {
									className: "",
									rows: 1,
									slidesPerRow: 1,
									slidesToScroll: 1,
									slidesToShow: 1,
								},
							},
						],
					}}
					slides={upgrades}
				/>
			</div>
			{children}
		</section>
	);
}

Upgrades.propTypes = {
	packageName: PropTypes.string.isRequired,
	modules: PropTypes.arrayOf(
		PropTypes.shape({
			content: PropTypes.string.isRequired,
			title: PropTypes.string.isRequired,
			url: PropTypes.string.isRequired,
		}),
	).isRequired,
	children: PropTypes.node,
};
